import {
  getEstimatedShippingValue,
  useCartAndDeliveryDatesDataContext,
  useCurrency,
} from '@app/data/clients/cartCheckoutClient';
import {
  monolithItemToAnalyticsItem,
  trackGA4ViewCart,
} from '@app/utils/analytics';
import { useEffect, useRef } from 'react';

export const useTrackGA4ViewCart = () => {
  const { cart } = useCartAndDeliveryDatesDataContext();
  const currency = useCurrency();

  const hasFiredEvent = useRef<boolean>(false);

  const couponCode = cart?.applied_coupon?.code;
  const value = cart?.summary.total || 0;

  const { estimated_shipping, show_tax_separately } = cart?.summary ?? {};
  const shipping = estimated_shipping
    ? getEstimatedShippingValue(
        estimated_shipping,
        show_tax_separately ?? false
      )
    : 0;

  const items = cart?.items.map((item, index) =>
    monolithItemToAnalyticsItem(
      item,
      currency,
      index,
      show_tax_separately ?? false
    )
  );

  useEffect(() => {
    if (items && !hasFiredEvent.current) {
      hasFiredEvent.current = true;
      trackGA4ViewCart({ currency, items, value, couponCode, shipping });
    }
  }, [value, items, couponCode, currency, shipping]);
};
